import { render, staticRenderFns } from "./PaymentFail.vue?vue&type=template&id=2bd552d3&"
import script from "./PaymentFail.vue?vue&type=script&lang=js&"
export * from "./PaymentFail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports